import React from 'react';
import { Typography, TextField, MenuItem } from '@mui/material';
import { colors, fonts } from '../../constants';

/**
 * RolePermissionsSection Component
 * Role and permissions form section
 */
const RolePermissionsSection = ({
  formData,
  errors,
  roles,
  onInputChange,
  onRoleChange,
}) => {
  return (
    <>
      <Typography 
        variant="subtitle2" 
        sx={{ 
          fontWeight: fonts.weightSemiBold, 
          color: colors.textPrimaryDark, 
          fontSize: '13px',
          mb: '4px',
          mt: '12px',
        }}
      >
        Role & Permissions
      </Typography>

      <TextField
        required
        select
        value={formData.role}
        onChange={onRoleChange}
        fullWidth
        size="small"
        error={!!errors.role}
        helperText={errors.role || 'Designation will be auto-filled based on role'}
        SelectProps={{
          displayEmpty: true,
          sx: { fontSize: '12px' },
          renderValue: (selected) => {
            if (!selected) {
              return 'Role *';
            }
            const selectedRole = roles.find((role) => role.value === selected);
            return selectedRole ? selectedRole.label : selected;
          },
        }}
        FormHelperTextProps={{
          sx: { fontSize: '11px', marginTop: errors.role ? '4px' : '0px' }
        }}
      >
        <MenuItem value="" disabled sx={{ fontSize: '12px', color: colors.textSecondary }}>
          Role *
        </MenuItem>
        {roles.map((role) => (
          <MenuItem key={role.value} value={role.value} sx={{ fontSize: '12px' }}>
            {role.label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        value={formData.designation}
        onChange={onInputChange('designation')}
        fullWidth
        size="small"
        disabled
        placeholder="Designation"
        helperText="Auto-filled based on selected role"
        InputProps={{
          sx: { 
            fontSize: '12px',
            '& input': {
              padding: '10px 12px',
              lineHeight: 1.4,
            }
          }
        }}
        FormHelperTextProps={{
          sx: { fontSize: '11px' }
        }}
      />
    </>
  );
};

export default RolePermissionsSection;

